import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { DeviceMonitoringFilterActionTypes, DeviceMonitoringFilterActions } from '../actions/device-monitoring-filter.actions';


@Injectable()
export class DeviceMonitoringFilterEffects {
  private actions$ = inject(Actions);
  loadDeviceMonitoringFilters$ = createEffect(() => this.actions$.pipe(
    ofType(DeviceMonitoringFilterActionTypes.LoadDeviceMonitoringFilters),
    /** An EMPTY observable only emits completion. Replace with your own observable API request */
    concatMap(() => EMPTY)
  ), { dispatch: false });


  constructor() {}

}
